import { render } from "./SottoProgettoODV.vue?vue&type=template&id=7100f0e9&ts=true"
import script from "./SottoProgettoODV.vue?vue&type=script&lang=ts"
export * from "./SottoProgettoODV.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__